// Add to cart product page logic, this is trigger to UpSelling Popup
document.addEventListener('DOMContentLoaded', async () => {
    if (typeof product === "undefined") {
      console.error("Product is undefined. Exiting.");
      return;
    }
    const variantsWrapper = document.querySelectorAll('.convert-packs__wrapper .variant-option');
    const productStatus = document.querySelectorAll('.convert-packs__wrapper .variant-option');
    const productForm = document.querySelector('.product-form .product-variant-id');
    const upsellingWrapper = document.querySelector('.popup-upselling');
    const productPageWrapper = document.querySelector('.product__info-wrapper');
    const cartDrawerWrapper = document.querySelector('.drawer');
    const productItemWrapper = document.querySelector('.cart-product_upselling--inner');
    const buttonClosePopup = document.querySelector('.upselling-close');
    const productAddToCard = productPageWrapper?.querySelector('.product-form__submit');
    const relatedUpsellingAddToCard = document.querySelectorAll('.popup-upselling__inner--related .product-form__submit')
    const overlayUpselling = document.createElement('div');
    const packDiscountWrapper = document.querySelector('.product-discount');
    const variantObj = window.variant_discount_pack;
    const discountObj = window.discount_items;
    const productObj = product;
    const productObjVariant = productObj?.variants;
    let packSavePrice = 0;
    let originalPrice = 0;
    let compareAtPrice = 0;
    let statusCheck = false;
    let currentPackProduct = false;
    let interval;

    variantsWrapper?.forEach(element => element ? currentPackProduct = true : currentPackProduct = false);

    productStatus?.forEach((btn) => {
      btn.addEventListener('click' , (e) => {
        if (btn.querySelector('input[data-value="Golden"]') || btn.querySelector('input[data-value="Producto"]')) {
          statusCheck = true;
        }else{
          statusCheck = false;
        }
      })
    });
        
    async function getCart() {
      const cartResponse = await fetch('/cart.json');
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        return cart;
      } else {
        return null;
      }
    }

    const showDescription = (item) => {
      const getPack = variantObj.find(element => element.id == item.id);
      if (getPack.pack_items) {
        packItems = getPack.pack_items.map(element => `<p class="pack-item">${element.title}</p>`).join('');
      }
    
      if (statusCheck) {
        return `<div class="product_description"><p>${item.product_description}</p></div>`;
      }else{
        return `
        <div class="product_description">
        <span class="pack_info">Artículos del pack:</span>
        ${packItems}
        </div>
        `;
      }

    }

    // Iteration of Save (%) pack
    const getVariantSavePrice = (item) => {
      const itemId = item.id;
      productObjVariant.forEach(element => {
        const variantId = element.id
        if (itemId == variantId) {
          const variantComparePrice = element.compare_at_price
          const variantOriginalPrice = element.price;
          const comparePrice = variantComparePrice - variantOriginalPrice;
          const iterationPrice = comparePrice * 100 / variantComparePrice;
          const priceCompare = variantComparePrice;
          const discountVariant = Math.floor(iterationPrice);
          originalPrice = numberWithCommas(priceCompare);
          packSavePrice = discountVariant;
          compareAtPrice = variantComparePrice;
        }
      })
    }

    function renderCartItem(item) {
      const itemVariant = item.variant_title.toLowerCase().replace(' ', '-');
      getVariantSavePrice(item);
      const regularPrice = item.discounted_price
      const savePriceUni = compareAtPrice - regularPrice
      return `
        <div class="cart-product__upselling--inner_box">
          <div class="product-img">
            <img id="image-responsive" class="responsive-image product_upselling" src="${item.image}" data-src="${item.image}" width="120" height="120" data-aspectratio="" data-sizes="auto" tabindex="-1" alt="" loading="lazy">
          </div>
          <div class="product-title">
            ${item.title}
          </div>
           ${showDescription(item)}
        </div>
        <div class="cart-product__upselling--inner_box">
          <div class="product-price">
            <div class="price price--sold-out">
              <div class="price__container">
                <div class="price__regular" style="display:none;">
                  <span class="visually-hidden visually-hidden--inline">Precio habitual</span>
                  <span class="price-item price-item--regular">
                    ${(item.price / 100).toFixed(2)}€
                  </span>
                </div>
                <div class="price__sale" style="display:block;">
                  <div class="price-content">
                    <span class="visually-hidden visually-hidden--inline">Precio habitual</span>
                    <span>
                      <s class="price-item price-item--regular">${originalPrice}€</s>
                    </span>
                    <span class="visually-hidden visually-hidden--inline">Precio de oferta</span>
                    <span class="price-item price-item--sale price-item--last">
                      ${(item.price / 100).toFixed(2)}€
                    </span>
                  </div>
                  <div class="css-1emmhiq">
                  <svg class="css-1101cbx" xmlns="http://www.w3.org/2000/svg" width="179" height="23" viewBox="0 0 179 23" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 18.1948V4.72929L10 0L179 0V23H10L0 18.1948ZM7.56363 8.53781C7.20247 8.52964 6.84321 8.58924 6.50698 8.71308C6.17075 8.83692 5.86435 9.02247 5.60579 9.25894C5.34723 9.49533 5.14174 9.77788 5.00141 10.0898C4.86107 10.4017 4.78872 10.7368 4.78862 11.0754C4.78852 11.4139 4.86066 11.7491 5.0008 12.061C5.14095 12.373 5.34627 12.6557 5.60468 12.8923C5.8631 13.1288 6.16939 13.3146 6.50554 13.4386C6.8417 13.5626 7.20092 13.6224 7.56209 13.6144C8.26927 13.5988 8.94196 13.3245 9.43632 12.8504C9.93068 12.3762 10.2076 11.7397 10.2077 11.0768C10.208 10.4139 9.93145 9.77723 9.4374 9.30277C8.94335 8.82839 8.27082 8.5538 7.56363 8.53781Z" fill="#3C3C3C"/>
                </svg>
                  ${ itemVariant == 'producto' ? '<span class="ahorra">Ahorras ' + (savePriceUni / 100).toFixed(2) + '€</span>' : '<span class="ahorra">Ahorras ' + packSavePrice + '%</span>'}
                </div>
                </div>
                <small class="unit-price caption hidden">
                  <span class="visually-hidden">Precio unitario</span>
                  <span class="price-item price-item--last">
                    <span></span>
                    <span aria-hidden="true">/</span>
                    <span class="visually-hidden">&nbsp;por&nbsp;</span>
                    <span>
                    </span>
                  </span>
                </small>
              </div>
            </div>
          </div>

          <div class="product-btn_checkout">
            <a type="button" href="/checkout" class="button button-primary button-checkout" product-data="${item.variant_id}">
              Finalizar compra
            </a>
          </div>
        </div>`;
    }

    function openUpsellHandler() {
      upsellingWrapper.setAttribute('open', '');
      document.body.append(overlayUpselling);
      overlayUpselling?.classList.add('overlay_upselling');
    }
  
    function closeUpsellHandler() {
      upsellingWrapper.removeAttribute('open');
      overlayUpselling.remove();
      cartDrawerWrapper.classList.add('active');
      document.body.classList.add('overflow-hidden');
      relatedUpsellingAddToCard.forEach(btn => {
        btn.removeAttribute('disabled')
        btn.removeAttribute('style')
      });
    }

    function evenClickAddToCard(){
      if (currentPackProduct && statusCheck) {
        interval = setInterval(() => {
          if (cartDrawerWrapper.classList.contains('active')) {
            cartDrawerWrapper.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
            clearInterval(interval);
          }
        });
    
        setTimeout(async () => {
          const cart = await getCart();
          if (cart && cart.items.length >= 0) {
            const cartItemsHTML = cart.items.filter(ele => ele.id == productForm.value).map(renderCartItem).join('');
            productItemWrapper.innerHTML = ''
            productItemWrapper.innerHTML = cartItemsHTML;
          }
          openUpsellHandler();
        }, 500);
      }
    };
    
    productAddToCard?.addEventListener('click' , async (e) => {
      evenClickAddToCard();
    });

    relatedUpsellingAddToCard?.forEach((btn, idx) =>
      btn.addEventListener('click' , async () => {
        evenClickAddToCard();
        const textBtn = btn.querySelector('span');
        textBtn.innerText = 'Producto agregado'
          setTimeout(() => {
            btn.setAttribute('disabled', '')
            btn.style.backgroundColor = 'black';
          }, 500);
    }));
  
    [buttonClosePopup, overlayUpselling].forEach(element => {
      element.addEventListener('click' , (e) => {
        closeUpsellHandler()
      });
    })
});
